if (!customElements.get('product-grading-system')) {
  customElements.define(
    'product-grading-system',
    class ProductGradingSystem extends window.BAO.CustomElement {
      constructor () {
        super()

        this.els.trigger.element.addEventListener('click', this.onClick)
      }

      onClick () {
        window.scrollTo({
          top:
            window.BAO.utils.getOffsetTop(
              window.BAO.utils.getElement(
                `[data-external-el="product-size-guide.target"]`
              )
            ) - 30,
          left: 0,
          behavior: 'smooth'
        })
        document
          .querySelectorAll('[data-product-size-tabs-el="trigger"]')
          .forEach(triggerEl => triggerEl.setAttribute('aria-pressed', false))
        document
          .querySelectorAll('[data-product-size-tabs-el="content"]')
          .forEach(contentEl => contentEl.setAttribute('aria-expanded', false))
        document
          .querySelector('[data-product-size-tabs-name="grading_system"]')
          .setAttribute('aria-pressed', true)
        document
          .querySelectorAll('[data-product-size-tabs-content="grading_system"]')
          .forEach(contentEl => contentEl.setAttribute('aria-expanded', true))
      }
    }
  )
}
